import styled, { css, keyframes } from 'styled-components';

import lightTheme from "../theme/lightBaseTheme";

const bannerTemplate = /*#__PURE__*/css(["position:absolute;top:0;left:0;right:0;bottom:0;"]);







const shimmerTransition = /*#__PURE__*/keyframes(["from{transform:translate3d(-100%,0,0);}to{transform:translate3d(100%,0,0);}"]);








// https://github.com/styled-components/stylelint-processor-styled-components/issues/247#issuecomment-525524944
const animationRule = /*#__PURE__*/css(
['', ' 2000ms infinite linear;'],
shimmerTransition);


function getTransparentColor(theme) {
  const lightModeTransparent = 'rgba(255, 255, 255, 0)';
  const darkModeTransparent = 'rgba(0, 0, 0, 0)';

  if (theme.colors.Background === lightTheme.colors.Background) {
    return lightModeTransparent;
  }

  return darkModeTransparent;
}

export const ShimmerContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "ShimmerEffectstyles__ShimmerContainer", componentId: "sc-7ibu4d-0" })(["", " overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(white,black);", ""],
bannerTemplate,





({ theme }) => css(["background-color:", ";:before{", " content:'';background-color:", ";}:after{", " content:'';transform:translate3d(-100%,0,0);animation:", ";background:linear-gradient( 90deg,", " 0%,", " 50%,", " 100% );}"],
theme.colors.Background,


bannerTemplate,

theme.colors['Level 1'],



bannerTemplate,


animationRule,


getTransparentColor(theme),
theme.colors.Background,
getTransparentColor(theme)));